









import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  HsabAccountNametag,
  InvestmentCustodian
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency.js";
import BalanceAmount from "@/employee/components/landing-pages/accountSummaryDashboard/BalanceAmount.vue";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";

@Component({
  components: {
    BalanceAmount
  }
})
export default class HsaAccountCardBody extends Vue {
  formatCurrency = formatCurrency;

  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  drivewealthStore = useDrivewealthStore();
  hsabInvestmentsStore = useHsabInvestmentStore();
  investmentThresholdStore = useInvestmentThresholdStore();

  @Prop({ required: true })
  account: HsabAccountNametag;

  mounted (): void {
    this.investmentThresholdStore.loadInvestmentThresholds({});
    this.loadBalance();
  }

  loadBalance () {
    this.investmentDailyBalanceStore.loadCurrentDailyBalance();
  }

  get displayInvestments (): boolean {
    return this.investmentThresholdStore.displayInvestmentsSection
        || this.investmentThresholdStore.displayLegacyHsabInvestmentsRedirectLink;
  }
}
